import getTokenData from './getTokenData';

export type TokenData = { iat: number; exp: number };

const validateTokenData = (token: string | null): TokenData | null => {
    if (!token) {
        return null;
    }

    try {
        const data = getTokenData(token);

        if (data.exp * 1000 > new Date().getTime()) {
            return data;
        }
    } catch (error) {
        // invalid data
        console.warn(error);
    }

    return null;
};

export default validateTokenData;
